/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_Tool_SendingInputs */

const en_mcp_demo_tool_sending = /** @type {(inputs: Mcp_Demo_Tool_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending`)
};

const es_mcp_demo_tool_sending = /** @type {(inputs: Mcp_Demo_Tool_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando`)
};

/**
* | output |
* | --- |
* | "Sending" |
*
* @param {Mcp_Demo_Tool_SendingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_tool_sending = /** @type {((inputs?: Mcp_Demo_Tool_SendingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_Tool_SendingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_tool_sending(inputs)
	return en_mcp_demo_tool_sending(inputs)
});